interface ProgressBarProps {
    accentColor?: string;
    showBranding?: boolean;
}

export default function PreviewProgressBar({
    accentColor = "#2563eb",
    showBranding = true,
}: ProgressBarProps) {
    // Use blue when: 1) branding off, 2) no accent color selected, 3) accent color selected but branding off
    const activeColor =
        !showBranding || accentColor === "#2563eb" ? "#2563eb" : accentColor;

    // Fixed steps and always 3/5 filled (at AI Interview step)
    const steps = [
        "Continue",
        "Form",
        "AI Interview",
        "Work Authorization",
        "Complete",
    ];

    const currentStep = 3; // Always at AI Interview step

    return (
        <div
            className="mt-4 max-w-4xl mx-auto w-full"
            style={{ paddingTop: "16px" }}
        >
            <div className="flex gap-6 mb-2">
                {steps.map((step, index) => (
                    <div className="flex flex-col items-center justify-center w-full gap-1" key={index}>
                        <div
                            className="flex h-2 rounded-full w-full"
                            style={{
                                backgroundColor: index < currentStep ? activeColor : "#d1d5db",
                            }}
                        />
                        <div key={index} className="flex-1 text-center font-medium">
                            <span
                                style={{
                                    color: index < currentStep ? activeColor : "#9ca3af",
                                }}
                            >
                                {step}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
